import { RefObject } from "react"
import { TourModalStep } from "../TourModal"

export const CONTRACTOR_CREATOR_MODAL_TOUR_ID = "contractor_creator_modal"

export interface ContractorCreatorModalTourRefs {
    tabs: RefObject<HTMLDivElement>
    counterpartyDetails: RefObject<HTMLDivElement>
    documentFlowSettings: RefObject<HTMLDivElement>
    contactData: RefObject<HTMLDivElement>
    responsiblePersons: RefObject<HTMLDivElement>
    additionalSettings: RefObject<HTMLDivElement>
    markingSettings: RefObject<HTMLDivElement>
}

const getTabsNav = (tabsRef: RefObject<HTMLDivElement>) => {
    return tabsRef.current?.querySelector<HTMLElement>(".ant-tabs-nav-list") ?? tabsRef.current
}

export const getContractorCreatorModalTourSteps = (refs: ContractorCreatorModalTourRefs): TourModalStep[] => [
    {
        target: () => getTabsNav(refs.tabs),
        description: (
            <ul>
                <li>Вкладка «Общие» - Общие данные контрагента</li>
                <li>Вкладка «Мотивация» - Расчёт дополнительной мотивации (бонусы и штрафы) для аптек.</li>
            </ul>
        ),
        placement: "bottom",
    },
    {
        target: () => refs.counterpartyDetails.current,
        description: (
            <div>
                Основные данные контрагента:
                <ul>
                    <li>Краткое наименование - обязательное поле, заполняется вручную</li>
                    <li>Мнемокод - необязательное поле, заполняется вручную</li>
                    <li>Код - необязательное поле, заполняется вручную</li>
                    <li>Полное наименование - обязательное поле, заполняется вручную</li>
                    <li>Юридическое лицо - обязательное поле, выбирается из справочника «Юридическое лицо»</li>
                    <li>Головной контрагент - необязательное поле, выбирается при наличии центрального офиса</li>
                    <li>КПП - необязательное поле, заполняется вручную</li>
                    <li>Материально ответственное лицо - необязательное поле, выбирается из справочника «Пользователи»</li>
                    <li>Модель ценообразования - необязательное поле, выбирается из справочника «Модели ценообразования»</li>
                </ul>
            </div>
        ),
        placement: "bottom",
    },
    {
        target: () => refs.documentFlowSettings.current,
        description: (
            <div>
                Настройки электронного документооборота:
                <ul>
                    <li>Формат импорта накладных - возможные варианты: dbf, sst, sst-Протек, xml-CommerceML</li>
                    <li>Настройка накладной - связка полей накладной поставщика с полями приходной накладной</li>
                    <li>Точка доступа - адрес, из которого будет производиться импорт накладных</li>
                    <li>Автозагрузка накладных - автоматическое отображение накладных из точки доступа в «Импорте накладных» и «Общем импорте накладных»</li>
                    <li>Автоимпорт накладных - автоматическая загрузка накладных из точки доступа в журнал Приходных накладных</li>
                    <li>Точка доступа для экспорта - адрес, на который будет производиться экспорт документов</li>
                    <li>Точка доступа интернет-заказов - адрес, из которого будет производиться загрузка интернет-заказов</li>
                    <li>Автоимпорт интернет-заказов - автоматическая загрузка интернет-заказов из точки доступа</li>
                </ul>
            </div>
        ),
        placement: "bottom",
    },
    {
        target: () => refs.contactData.current,
        description: (
            <div>
                Контактные данные:
                <ul>
                    <li>Телефон</li>
                    <li>e-mail</li>
                    <li>адрес</li>
                </ul>
                необязательные данные, могут использоваться в отчётах.
            </div>
        ),
        placement: "top",
    },
    {
        target: () => refs.responsiblePersons.current,
        description: (
            <div>
                Ответственные лица:
                <ul>
                    <li>ФИО нач. мед</li>
                    <li>ФИО зав. отделением</li>
                    <li>ФИО главная медсестра</li>
                    <li>ФИО старшая медсестра</li>
                </ul>
                необязательные данные, могут использоваться в отчётах.
            </div>
        ),
        placement: "top",
    },
    {
        target: () => refs.additionalSettings.current,
        description: (
            <div>
                Дополнительные настройки:
                <ul>
                    <li>Филиал - указать, если контрагент является филиалом</li>
                    <li>Доверенный поставщик - при разагрегации коробов от данного контрагента необязательно сканировать состав короба</li>
                    <li>Плательщик НДС - указать, если контрагент является плательщиком НДС</li>
                    <li>Комитент - указать, если контрагент является комитентом</li>
                    <li>Поставщик по умолчанию - данный контрагент будет автоматически указан, как «Поставщик» в новой создаваемой приходной накладной</li>
                    <li>СНО - возможные варианты: отсутствует, Основная СНО, УСН (5%), УСН (7%)</li>
                    <li>Часовой пояс - часовой пояс, в котором находится данный контрагент</li>
                </ul>
            </div>
        ),
        placement: "top",
    },
    {
        target: () => refs.markingSettings.current,
        description: (
            <div>
                Настройки, необходимые для обмена с МДЛП «Честный Знак»:
                <ul>
                    <li>Импортировать из МДЛП - при включённом состоянии будет автоматически запрашиваться состав коробов и паллет</li>
                    <li>Код в системе 'Маркировка' - код места деятельности, выданный Честным Знаком. Его можно узнать в личном кабинете Честного Знака</li>
                    <li>Тип акцепта: Прямой - информация об отгрузке лексредств сначала передается поставщиком, затем подтверждается получателем</li>
                    <li>Тип акцепта: Обратный - информация о получении лексредств сначала передается получателем, затем подтверждается поставщиком</li>
                    <li>Уведомительный режим - КИЗы лекарственных средств будут доступны для продажи сразу же после отработки документов. Незаконно с 1 сентября 2024 года.</li>
                    <li>Адрес ФИАС - идентификатор адреса из системы ФИАС</li>
                </ul>
            </div>
        ),
        placement: "top",
    },
]
